<div
  [class.required]="model.required"
  class="ion-text-xl-left ion-text-lg-left ion-text-md-left ion-text-sm-left question"
>
  <ion-item
    [class.answerRequired]="model.highlight && currentValue == null"
    class="ion-align-items-center ion-text-wrap ion-no-padding"
    lines="none"
  >
    @if (!loading) {
      <ion-select
        #selectRef
        labelPlacement="start"
        label="{{model.questionResolved}}"
        multiple="false"
        [value]="currentValue"
        okText='{{ "BUTTONS.SAVE" | translate }}'
        cancelText='{{ "BUTTONS.CANCEL" | translate }}'
        [disabled]="model.isDisabled"
        (ionChange)="emitAnswer($event.detail.value)"
      >
        @for (option of model.options; track $index; let i = $index) {
          <ion-select-option [value]="model.values[i]">
            {{ model.optionsResolved[i] }}
          </ion-select-option>
        }
      </ion-select>
    }
  </ion-item>
</div>
